(function () {
  var root = document.getElementById('rc-cart');
  if (!root || window.__runicCart) return;
  window.__runicCart = true;
  document.body.appendChild(root);

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('rc-data').textContent) || {}; } catch (e) {}
  var S = cfg.i18n || {};
  var base = cfg.root || '/';
  if (base.slice(-1) !== '/') base += '/';

  var panel = root.querySelector('.rc-panel');
  var body = root.querySelector('.rc-body');
  var foot = root.querySelector('.rc-foot');
  var countEl = root.querySelector('.rc-count');
  var subEl = root.querySelector('.rc-sub strong');
  var toast = root.querySelector('.rc-toast');
  var toastTxt = toast.querySelector('span');
  var noteIn = root.querySelector('.rc-note-input');
  var couponForm = root.querySelector('.rc-coupon');
  var couponIn = root.querySelector('.rc-coupon input');
  var codesEl = root.querySelector('.rc-codes');
  var couponMsg = root.querySelector('.rc-coupon-msg');
  var discRow = root.querySelector('.rc-disc');
  var totRow = root.querySelector('.rc-tot');
  var agree = root.querySelector('.rc-agree input');
  var agreeBox = root.querySelector('.rc-agree');
  var checkoutBtn = root.querySelector('.rc-checkout');
  var lastFocus = null, closeT = null, toastT = null, cart = null, noteT = null;

  var ICON_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"></path></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>';
  var ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2L5 8z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg>';

  function mk(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function money(cents, cur) {
    var v = (cents || 0) / 100;
    if (!cur || cur === 'TRY') return Math.round(v).toLocaleString('tr-TR') + ' TL';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(v); }
    catch (e) { return v.toFixed(2) + ' ' + cur; }
  }
  function img(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function api(path, data) {
    var opt = { headers: { Accept: 'application/json' } };
    if (data) {
      opt.method = 'POST';
      if (data instanceof FormData) opt.body = data;
      else { opt.body = JSON.stringify(data); opt.headers['Content-Type'] = 'application/json'; }
    }
    return fetch(base + path, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'error'); err.data = j; throw err; } return j; });
    });
  }

  /* ---------- Sayac (header) ---------- */
  function syncHeader(c, bump) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      if (root.contains(el)) return;
      el.textContent = c.item_count;
      el.classList.toggle('t4s-op-0', !c.item_count);
      if (bump) { el.classList.remove('rc-bump'); void el.offsetWidth; el.classList.add('rc-bump'); }
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-tt-price]'), function (el) {
      el.textContent = money(c.total_price, c.currency);
    });
  }

  /* ---------- Cizim ---------- */
  function renderEmpty() {
    body.innerHTML = '';
    var w = mk('div', 'rc-empty');
    w.innerHTML = ICON_BAG;
    w.appendChild(mk('p', '', S.empty));
    var a = mk('a', '', S.emptyCta);
    a.href = cfg.newUrl || base;
    w.appendChild(a);
    body.appendChild(w);
    foot.hidden = true;
  }

  /* Renk gorseli: varyantin kendi gorseli yoksa 'ecomposer-renk-<renk>' alt metinli urun gorseli */
  var prodCache = {};
  function slug(t) {
    return String(t || '').toLowerCase().replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's').replace(/ö/g, 'o').replace(/ç/g, 'c')
      .normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function colorImg(it, im) {
    if (!it.handle || !it.variant_title) return;
    var vals = (it.options_with_values || []).map(function (o) { return o.value; });
    if (!vals.length) vals = String(it.variant_title).split(' / ');
    if (!prodCache[it.handle]) {
      prodCache[it.handle] = fetch(base + 'products/' + it.handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    prodCache[it.handle].then(function (p) {
      if (!p || !p.media) return;
      for (var k = 0; k < vals.length; k++) {
        var want = 'ecomposer-renk-' + slug(vals[k]);
        for (var m = 0; m < p.media.length; m++) {
          var md = p.media[m];
          if (md.alt === want && md.src) { im.src = img(md.src, 240); return; }
        }
      }
    });
  }

  function renderItem(it, i) {
    var row = mk('div', 'rc-item');
    row.setAttribute('data-key', it.key);
    row.setAttribute('data-variant', it.variant_id);
    row.style.animationDelay = Math.min(i * 0.04, 0.3) + 's';

    var pic = mk('a', 'rc-img');
    pic.href = it.url;
    var src = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
    if (src) {
      var im = document.createElement('img');
      im.src = img(src, 240);
      im.alt = it.product_title;
      im.loading = 'lazy';
      pic.appendChild(im);
      colorImg(it, im);
    }
    row.appendChild(pic);

    var info = mk('div', 'rc-info');
    var top = mk('div', 'rc-top');
    var name = mk('a', 'rc-name', it.product_title);
    name.href = it.url;
    top.appendChild(name);
    var pr = mk('span', 'rc-price');
    if (it.original_line_price > it.final_line_price) pr.appendChild(mk('s', 'rc-was', money(it.original_line_price, cart.currency)));
    pr.appendChild(document.createTextNode(money(it.final_line_price, cart.currency)));
    top.appendChild(pr);
    info.appendChild(top);

    if (it.variant_title && !it.product_has_only_default_variant) info.appendChild(mk('span', 'rc-variant', it.variant_title));

    var props = it.properties || {};
    var keys = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && props[k] !== '' && props[k] != null && String(props[k]).indexOf('/uploads/') < 0; });
    if (keys.length) {
      var ul = mk('ul', 'rc-props');
      keys.slice(0, 6).forEach(function (k) {
        var li = mk('li');
        li.appendChild(mk('b', '', k + ': '));
        li.appendChild(document.createTextNode(String(props[k])));
        ul.appendChild(li);
      });
      info.appendChild(ul);
    }

    var r2 = mk('div', 'rc-row');
    var q = mk('div', 'rc-qty');
    var minus = mk('button');
    minus.type = 'button';
    minus.innerHTML = ICON_MINUS;
    minus.setAttribute('aria-label', '−');
    minus.setAttribute('data-q', it.quantity - 1);
    var qv = mk('span', '', String(it.quantity));
    var plus = mk('button');
    plus.type = 'button';
    plus.innerHTML = ICON_PLUS;
    plus.setAttribute('aria-label', '+');
    plus.setAttribute('data-q', it.quantity + 1);
    q.appendChild(minus); q.appendChild(qv); q.appendChild(plus);
    r2.appendChild(q);
    var rm = mk('button', 'rc-remove', S.remove);
    rm.type = 'button';
    rm.setAttribute('data-q', '0');
    r2.appendChild(rm);
    info.appendChild(r2);

    row.appendChild(info);
    return row;
  }

  function render(c) {
    cart = c;
    countEl.textContent = c.item_count;
    countEl.hidden = !c.item_count;
    syncHeader(c);
    if (!c.item_count) { renderEmpty(); return; }
    body.innerHTML = '';
    c.items.forEach(function (it, i) { body.appendChild(renderItem(it, i)); });
    var disc = c.total_discount || 0;
    subEl.textContent = money(disc ? (c.original_total_price || c.items_subtotal_price + disc) : c.total_price, c.currency);
    discRow.hidden = !disc;
    totRow.hidden = !disc;
    if (disc) {
      discRow.querySelector('strong').textContent = '−' + money(disc, c.currency);
      totRow.querySelector('strong').textContent = money(c.total_price, c.currency);
    }
    if (noteIn && document.activeElement !== noteIn) {
      noteIn.value = c.note || '';
      if (c.note) noteIn.closest('details').open = true;
    }
    renderCodes(c);
    foot.hidden = false;
  }

  /* ---------- Indirim kodu ---------- */
  function activeCodes(c) {
    return ((c && c.discount_codes) || []).map(function (d) { return d.code; });
  }
  function renderCodes(c) {
    if (!codesEl) return;
    codesEl.innerHTML = '';
    ((c && c.discount_codes) || []).forEach(function (d) {
      var code = d.code;
      var chip = mk('span', 'rc-code' + (d.applicable ? '' : ' is-pending'));
      if (!d.applicable) chip.title = S.couponPending || '';
      chip.appendChild(mk('span', '', code));
      var x = mk('button');
      x.type = 'button';
      x.setAttribute('data-code', code);
      x.setAttribute('aria-label', S.remove + ' ' + code);
      x.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
      chip.appendChild(x);
      codesEl.appendChild(chip);
    });
    if (activeCodes(c).length) couponForm.closest('details').open = true;
  }
  function setCodes(list) {
    return api('cart/update.js', { discount: list.join(',') }).then(function () { return api('cart.js'); });
  }
  function couponNote(msg, bad) {
    couponMsg.textContent = msg || '';
    couponMsg.classList.toggle('is-bad', !!bad);
  }
  if (couponForm) {
    couponForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var code = (couponIn.value || '').trim();
      if (!code) return;
      var cur = activeCodes(cart);
      if (cur.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { couponIn.value = ''; return; }
      couponForm.classList.add('is-busy');
      couponNote('');
      setCodes(cur.concat(code)).then(function (c) {
        var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        couponIn.value = '';
        render(c);
        couponNote(hit && hit.applicable ? '' : S.couponPending, false);
        return c;
      }).catch(function () { couponNote(S.couponBad, true); refresh(); })
        .then(function () { couponForm.classList.remove('is-busy'); });
    });
  }
  if (codesEl) {
    codesEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-code]');
      if (!b) return;
      var code = b.getAttribute('data-code');
      b.closest('.rc-code').classList.add('is-busy');
      setCodes(activeCodes(cart).filter(function (c) { return c !== code; })).then(render).catch(refresh);
    });
  }

  /* ---------- Siparis notu ---------- */
  if (noteIn) {
    noteIn.addEventListener('input', function () {
      clearTimeout(noteT);
      noteT = setTimeout(function () { api('cart/update.js', { note: noteIn.value }).catch(function () {}); }, 600);
    });
    noteIn.addEventListener('blur', function () {
      clearTimeout(noteT);
      api('cart/update.js', { note: noteIn.value }).catch(function () {});
    });
  }

  /* ---------- Sozlesme onayi ---------- */
  if (agree) {
    agree.addEventListener('change', function () {
      agreeBox.classList.remove('is-err');
      var attrs = {};
      attrs[S.attrName || 'Sözleşme onayı'] = agree.checked ? (S.attrYes || 'Onaylandı') + ' · ' + new Date().toISOString() : '';
      api('cart/update.js', { attributes: attrs }).catch(function () {});
    });
  }
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      if (agree && !agree.checked) {
        e.preventDefault();
        agreeBox.classList.remove('is-err');
        void agreeBox.offsetWidth;
        agreeBox.classList.add('is-err');
        return;
      }
      if (noteIn) {
        e.preventDefault();
        var href = checkoutBtn.getAttribute('href');
        clearTimeout(noteT);
        checkoutBtn.classList.add('is-busy');
        api('cart/update.js', { note: noteIn.value }).catch(function () {}).then(function () { window.location.href = href; });
      }
    });
  }

  function loading() {
    if (cart) return;
    body.innerHTML = '<div class="rc-loading"><span></span></div>';
    foot.hidden = true;
  }

  function showToast(msg, ok) {
    clearTimeout(toastT);
    toastTxt.textContent = msg;
    toast.querySelector('svg').style.display = ok ? '' : 'none';
    toast.classList.add('is-on');
    toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  function refresh() { return api('cart.js').then(render).catch(function () {}); }

  /* ---------- Ac / kapat ---------- */
  function open() {
    clearTimeout(closeT);
    if (root.hidden) {
      lastFocus = document.activeElement;
      root.hidden = false;
    }
    document.documentElement.classList.add('rc-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    var x = root.querySelector('.rc-close');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('rc-lock');
    closeT = setTimeout(function () { root.hidden = true; }, 460);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openCart() {
    loading();
    Array.prototype.forEach.call(body.querySelectorAll('.rc-item'), function (r) { r.classList.add('is-busy'); });
    open();
    refresh();
  }
  window.RunicCart = { open: openCart, close: close, refresh: refresh };

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-rc-close]')) { e.preventDefault(); close(); return; }
    var b = e.target.closest('[data-q]');
    if (!b) return;
    var row = b.closest('.rc-item');
    if (!row || row.classList.contains('is-busy')) return;
    e.preventDefault();
    row.classList.add('is-busy');
    changeLine(row.getAttribute('data-key'), row.getAttribute('data-variant'), Number(b.getAttribute('data-q')))
      .then(render)
      .catch(function () { row.classList.remove('is-busy'); showToast(S.error, false); refresh(); });
  });

  // Satir anahtari eskimisse (geri tusu, baska sekme, cift dokunus) guncel sepetten satiri bulup tekrar dener.
  function changeLine(key, variant, qty) {
    return api('cart/change.js', { id: key, quantity: qty }).catch(function () {
      return api('cart.js').then(function (c) {
        var idx = -1;
        c.items.forEach(function (it, i) { if (idx < 0 && it.key === key) idx = i; });
        if (idx < 0) {
          var same = [];
          c.items.forEach(function (it, i) { if (String(it.variant_id) === String(variant)) same.push(i); });
          if (same.length === 1) idx = same[0];
        }
        if (idx < 0) return c;
        return api('cart/change.js', { line: idx + 1, quantity: qty });
      });
    });
  }

  // Sayfa geri tusuyla onbellekten donunce veya sekmeye geri gelinince sepeti tazeler.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) { e.preventDefault(); close(); }
  });

  /* ---------- Sepet ikonu ---------- */
  function isCartLink(a) {
    if (!a || !a.href || root.contains(a) || a.target === '_blank') return false;
    try {
      var u = new URL(a.href, location.href);
      if (u.origin !== location.origin) return false;
      return /\/cart\/?$/.test(u.pathname);
    } catch (e) { return false; }
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a[href], [data-rc-open]');
    if (!a) return;
    if (!a.hasAttribute('data-rc-open') && !isCartLink(a)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openCart();
  }, true);

  /* ---------- Sepete ekle ---------- */
  function isAddForm(f) {
    var act = f && f.getAttribute && (f.getAttribute('action') || '');
    return /\/cart\/add\/?(\?|$)/.test(act);
  }
  var busy = false;
  function addForm(form, submitter) {
    if (busy) return;
    busy = true;
    var fd;
    try { fd = submitter ? new FormData(form, submitter) : new FormData(form); } catch (e) { fd = new FormData(form); }
    var btns = form.querySelectorAll('[type="submit"], .ecom-product-single__add-to-cart--submit');
    Array.prototype.forEach.call(btns, function (b) { b.classList.add('rc-adding'); b.setAttribute('aria-busy', 'true'); });
    cart = null;
    loading();
    open();
    api('cart/add.js', fd)
      .then(function () { return api('cart.js'); })
      .then(function (c) { render(c); syncHeader(c, true); showToast(S.added, true); })
      .catch(function (err) { refresh(); showToast(err.message || S.error, false); })
      .then(function () {
        busy = false;
        Array.prototype.forEach.call(btns, function (b) { b.classList.remove('rc-adding'); b.removeAttribute('aria-busy'); });
      });
  }
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !isAddForm(f)) return;
    e.preventDefault();
    addForm(f, e.submitter);
  });
  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isAddForm(this)) { addForm(this); return; }
    return nativeSubmit.apply(this, arguments);
  };

  document.addEventListener('visibilitychange', function () { if (!document.hidden && !root.hidden) refresh(); });
})();
